import { render, staticRenderFns } from "./StartingPage.vue?vue&type=template&id=4e48921d&scoped=true&"
import script from "./StartingPage.vue?vue&type=script&lang=js&"
export * from "./StartingPage.vue?vue&type=script&lang=js&"
import style0 from "./StartingPage.vue?vue&type=style&index=0&id=4e48921d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48921d",
  null
  
)

export default component.exports